import { render, staticRenderFns } from "./LanguageAbilityModal.vue?vue&type=template&id=2fd4f556&scoped=true&"
import script from "./LanguageAbilityModal.vue?vue&type=script&lang=js&"
export * from "./LanguageAbilityModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd4f556",
  null
  
)

export default component.exports